if (!customElements.get('component-presale-model')) {
  customElements.define('component-presale-model', class presaleModel extends HTMLElement {
    constructor() {
      super();
      this.notifyMeContainer = this.querySelector('component-notify-me');
      this.closeNotifyMeButton = this.querySelector('.notify-content-close-btn');
      this.continueButton = this.querySelector('.notify-me-button');
      this.varaiantOptions = this.querySelectorAll('.notify-me-variant');
      this.selectedVariantId;
    }

    _isIPhoneOrIPad = () => window.navigator.userAgent.match(/iPad/i) || window.navigator.userAgent.match(/iPhone/i);

    connectedCallback() {
      this.addEventListeners();
    }

    toggleNotifyMePopUp(event, selectedVariant) {
      const isIPhoneOrIPad = this._isIPhoneOrIPad();
      const body = document.querySelector('body');
      body.style.overflow = body.style.overflow === 'hidden' ? 'auto' : 'hidden';
      this.classList.toggle('hide-notify-popup');

      if (event === 'open') {
        if (isIPhoneOrIPad && this.closest('.section-grid-view-wrapper')) this.closest('.section-grid-view-wrapper').classList.add('notify-popup-visible');
        const optionToSelect = Array.from(this.varaiantOptions).find(varaint => selectedVariant == varaint.dataset.variantId);
        this.selectedVariantId = selectedVariant;
        optionToSelect.classList.add('notify-me-variant-selected');
      }

      if (event === 'close') {
        if (isIPhoneOrIPad && this.closest('.section-grid-view-wrapper')) this.closest('.section-grid-view-wrapper').classList.remove('notify-popup-visible');
        this.varaiantOptions.forEach((variant) => variant.classList.remove('notify-me-variant-selected'));
      }
    }

    addEventListeners() {
      this.closeNotifyMeButton && this.closeNotifyMeButton.addEventListener('click', this.toggleNotifyMePopUp.bind(this, 'close'));
      this.continueButton && this.continueButton.addEventListener('click', this.toggleNotifyMePopUp.bind(this, 'close'));
    }
  })
}
